import * as React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { SessionExpiredDialog } from "lib/components/SessionExpiredDialog";
import { Notification } from "lib/components/Notification";
import I18n from "lib/I18n";
import style from "./style.module.css";
import { EntryList } from "../EntryList";
import { JsonExchanger } from "../JsonExchanger";
import { Deployment } from "../Deployment";
import { S3 } from "../S3";
import { LoadStatus } from "../LoadStatus";
import { TableStatus } from "../TableStatus";
import { S3Delete } from "../S3Delete";
import { getStore } from "../../store";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

export const App = observer(() => {
  const { app, list } = getStore();

  useEffect(() => {
    list.reloadDefinition();
  }, []);

  const handleChangeRightTab = (key: unknown) => {
    // react-bootstrapのバグ回避
    if (typeof key === "string") {
      app.tab = key;
    }
  };

  return (
    <div className={style.root}>
      <Tabs
        activeKey={app.tab}
        onSelect={handleChangeRightTab}
        className={style.tabs}
        transition={false}
        unmountOnExit
        id="mainNav"
      >
        <Tab
          title={I18n.t("event_master_editor.tab.entry_list")}
          eventKey="EntryList"
        >
          <EntryList />
        </Tab>
        <Tab
          title={I18n.t("event_master_editor.tab.deployment")}
          eventKey="Deployment"
        >
          <Deployment />
        </Tab>
        <Tab
          title={I18n.t("event_master_editor.tab.csv_exchanger")}
          eventKey="Import/Export"
        >
          <JsonExchanger />
        </Tab>
        {app.userAdmin ? (
          <Tab title={I18n.t("event_master_editor.tab.s3")} eventKey="S3">
            <S3 />
          </Tab>
        ) : undefined}
        <Tab
          title={I18n.t("event_master_editor.tab.load_status")}
          eventKey="LoadStatus"
        >
          <LoadStatus />
        </Tab>
        <Tab
          title={I18n.t("event_master_editor.tab.table_status")}
          eventKey="TableStatus"
        >
          <TableStatus />
        </Tab>
        <Tab
          title={I18n.t("event_master_editor.tab.s3_delete")}
          eventKey="S3Delete"
        >
          <S3Delete />
        </Tab>
      </Tabs>
      <SessionExpiredDialog />
      <Notification />
    </div>
  );
});
